import { atomWithSyncStorage, createSyncJotaiStorage } from "@payping/utilities-browser/state-management";
import { APP_CORE_STATE_KEYS } from "./keys";
import { Direction, DIRECTIONS, Language, LANGUAGES } from "@payping/utilities-shared/consts";

type Theme = "dark" | "light" | "system";

// const defaultBrowserTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

type Tours = "overview";
interface DashboardPreferencesAtom {
  tours: Record<Tours, { isSeen: boolean }>;
  user: {
    otpLastTime?: string;
  };
  urlForLoginRedirect: string;
  serviceWorker: {
    hasUpdate: boolean;
  };
  theme: {
    color: Theme;
    compact: boolean;
  };
  direction: Direction;
  language: Language;
  appVersion: { current?: string; latest?: string; supported?: string };
}

export const dashboardPreferencesAtom = atomWithSyncStorage<DashboardPreferencesAtom>(
  APP_CORE_STATE_KEYS.dashboardPreferences,
  {
    tours: {
      overview: {
        isSeen: true,
      },
    },
    user: {
      otpLastTime: undefined,
    },
    urlForLoginRedirect: "",
    serviceWorker: {
      hasUpdate: false,
    },
    theme: {
      color: "light",
      compact: false,
    },
    direction: DIRECTIONS.RTL,
    language: LANGUAGES.FARSI,
    appVersion: { current: process.env.REACT_APP_VERSION ?? "0", latest: "0", supported: "0" },
  },
  createSyncJotaiStorage(),
);
